<template>
  <el-row style="height: 518px;">
    <el-col :span="12" style="height: 100%;">
      <app-base-main
          :table-shadow="false"
          border
          table-border-top
          style="padding: 12px"
          class="base-main__left--picker">
        <template #filter-group>
          <app-filter-group
              :reset="false"
              :isBr="false "
              @query="$gjNoticeQuery">
            <gj-market-select
                v-model="filter.marketId"
                placeholder="全部店铺"
                width="140px"
            ></gj-market-select>
            <gj-select-input
                v-model="filter.keyword"
                :options="option.keyword"
            ></gj-select-input>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
              :index="false"
              :loading="loading"
              :data="originTableData"
              :columns="originColumns"
              size="has-picture"
              :adapt-height="false"
              :height="400"
              :pagination="pagination"
              :pagination-option="{layout: 'total, prev, pager, next, sizes'}"
              @page-change="$gjNoticeQuery">
            <template v-slot:header:op>
              <gj-button
                  type="text"
                  @click="addAllItem()">添加全部</gj-button>
            </template>
            <template v-slot:title="{row}">
              <div>
                <span class="gj-table--label">店铺：</span>{{row.marketId | optionText(marketOption) | defaultShow}}
              </div>
              <div>
                <gj-tooltip :text-line="1" :content="row.title">
                  {{row.title | defaultShow}}
                </gj-tooltip>
              </div>
              <el-row>
                <el-col :span="12">
                  <gj-tooltip :text-line="1" :content="row.asin">
                    <span class="gj-table--label">ASIN：</span>
                    <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
                  </gj-tooltip>
                </el-col>
                <el-col :span="12">
                  <gj-tooltip :text-line="1" :content="row.msku">
                    <span class="gj-table--label">MSKU：</span>
                    <span>{{row.msku | defaultShow}}</span>
                  </gj-tooltip>
                </el-col>
              </el-row>
            </template>
            <template v-slot:op="{row}">
              <gj-button
                  type="text"
                  :disabled="row.addBtnDisabled"
                  @click="addItem(row)">添加</gj-button>
            </template>
          </gj-table>
        </template>
      </app-base-main>
    </el-col>
    <el-col :span="12" style="height: 100%;">
      <app-base-main
          :table-shadow="false"
          border
          table-border-top
          size="has-picture"
          style="padding: 12px"
          class="base-main__right--picker">
        <template #filter-group>
          <div style="margin: 7px 0 6px;">
            <span>已添加 {{form.asinItems.length}} 个商品</span>
          </div>
        </template>
        <template #table>
          <gj-table
              :index="false"
              :data="form.asinItems"
              :columns="pickerColumns"
              :adapt-height="false"
              :height="450">
            <template v-slot:header:op>
              <gj-button
                  type="text"
                  @click="deleteAllItem">移除全部</gj-button>
            </template>
            <template v-slot:title="{row}">
              <div>
                <span class="gj-table--label">店铺：</span>{{row.marketId | optionText(marketOption) | defaultShow}}
              </div>
              <div>
                <gj-tooltip :text-line="1" :content="row.title">
                  {{row.title | defaultShow}}
                </gj-tooltip>
              </div>
              <el-row>
                <el-col :span="12">
                  <gj-tooltip :text-line="1" :content="row.asin">
                    <span class="gj-table--label">ASIN：</span>
                    <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
                  </gj-tooltip>
                </el-col>
                <el-col :span="12">
                  <gj-tooltip :text-line="1" :content="row.msku">
                    <span class="gj-table--label">MSKU：</span>
                    <span>{{row.msku | defaultShow}}</span>
                  </gj-tooltip>
                </el-col>
              </el-row>
            </template>
            <template v-slot:op="{row, index}">
              <gj-button
                  type="text"
                  @click="deleteItem(row, index)">移除</gj-button>
            </template>
          </gj-table>
        </template>
      </app-base-main>
    </el-col>
  </el-row>
</template>

<script>
  import {queryMixin} from "../../../../../../../minxins";
  import {getOperationLogListingPage} from "../../../../../../../api/sale";
  import {OperationLogEnum} from "../../../common/enum";
  import {isMeaningful, meaningfulEq} from "../../../../../../../utils/common";
  import {mapGetters} from "vuex";

  export default {
    name: "app-asin-operation-log-picker",
    mixins: [queryMixin],
    props: {
      form: {
        required: true
      }
    },
    data() {
      return {
        originTableData: [],
        originColumns: [
          {id: 'picture', header: '图片', field: 'picture:imageUrl', width: '50px'},
          {id: 'title', header: '店铺/商品标题/ASIN/MSKU', field: 'slot:title', minWidth: '220px'},
          {id: 'variationAsin', header: '父ASIN', field: 'variationAsin', width: '120px'},
          {id: 'op', header: 'slot:op', field: 'slot:op', width: '80px', fixed: 'right'},
        ],
        pickerColumns: [
          {id: 'picture', header: '图片', field: 'picture:imageUrl', width: '50px'},
          {id: 'title', header: '店铺/商品标题/ASIN/MSKU', field: 'slot:title', minWidth: '220px'},
          {id: 'variationAsin', header: '父ASIN', field: 'variationAsin', width: '120px'},
          {id: 'op', header: 'slot:op', field: 'slot:op', width: '80px', fixed: 'right'},
        ],
        filter: {
          marketId: null,
          keyword: {
            key: 'asin',
            value: null
          }
        },
        option: {
          keyword: [
            {id: 'asin', text: 'ASIN'},
            {id: 'msku', text: 'MSKU'},
            {id: 'variationAsin', text: '父ASIN'},
          ]
        }
      }
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            dimension: OperationLogEnum.dimension.ASIN,
            marketId: this.filter.marketId
          },
          ...this.queryPagination,
          ...this.querySort
        };
        params.model[this.filter.keyword.key] = this.filter.keyword.value;
        // 查询
        this.loading = true;
        getOperationLogListingPage(params)
          .then((data) => {
            this.originTableData = (data.records || []);
            this.pagination = this.getPagination(data);
            this.refreshAddBtn();
          })
          .complete(() => this.loading = false);
      },
      addAllItem() {
        this.form.asinItems = this.form.asinItems.concat(this.originTableData.filter(item => !item.addBtnDisabled));
        this.refreshAddBtn();
      },
      addItem(row) {
        if (this.form.asinItems.every(item => item.msku !== row.msku)) {
          this.form.asinItems.push(row);
          this.refreshAddBtn();
        }
      },
      deleteAllItem() {
        this.form.asinItems = [];
        this.refreshAddBtn();
      },
      deleteItem(index) {
        this.form.asinItems.splice(index, 1);
        this.refreshAddBtn();
      },
      refreshAddBtn() {
        if (isMeaningful(this.originTableData)) {
          this.originTableData.forEach(item => {
            const find = (this.form.asinItems || []).some(pickedItem => {
              return meaningfulEq(item.msku, pickedItem.msku);
            });
            if (find) {
              this.$set(item, 'addBtnDisabled', true);
            } else {
              this.$set(item, 'addBtnDisabled', false);
            }
          });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .footer__pagination {
    padding: 7px 0 5px 16px;
  }
  /deep/ .el-pagination {
    margin-right: 0;
  }
  /deep/ .base-main__left--picker{
    min-height: 492px;
  }
</style>





















